// Types
export const Types = {
  GET_INSTITUTIONS: 'GET_INSTITUTIONS',
  GET_PAGED_INSTITUTIONS: 'GET_PAGED_INSTITUTIONS',
  GET_EXTERNAL_INSTITUTIONS: 'GET_EXTERNAL_INSTITUTIONS',
  GET_INTERNAL_INSTITUTIONS: 'GET_INTERNAL_INSTITUTIONS',
  GET_INSTITUTION: 'GET_INSTITUTION',
  CREATE_INSTITUTIONS: 'CREATE_INSTITUTIONS',
  UPDATE_INSTITUTION: 'UPDATE_INSTITUTION',
  DELETE_INSTITUTION: 'DELETE_INSTITUTION',
  REACTIVATE_INSTITUTION: 'REACTIVATE_INSTITUTION',
  SET_LOADING: "SET_LOADING_INSTITUTION",
};

// Reducer
const initialState = {
  institutions: null,
  pagedInstitutions: null,
  externalInstitutions: null,
  internalInstitutions: null,
  institution: null,

  loading: false,
};

const Institutions = (state=initialState, action) => {
  switch (action.type) {
    case Types.GET_INSTITUTIONS:
      return {
        ...state,
        institutions: action.payload,
        loading: false,
      }
    case Types.GET_PAGED_INSTITUTIONS:
      return {
        ...state,
        pagedInstitutions: action.payload,
        loading: false,
      }
    case Types.GET_EXTERNAL_INSTITUTIONS:
        return {
          ...state,
          externalInstitutions: action.payload,
          loading: false,
        }
    case Types.GET_INTERNAL_INSTITUTIONS:
      return {
        ...state,
        internalInstitutions: action.payload,
        loading: false,
      }
    case Types.GET_INSTITUTION:
        return {
          ...state,
          institution: action.payload,
          loading: false,
        }
    case Types.CREATE_INSTITUTIONS:
      return {
        ...state,
        // institution: action.payload,
        loading: false,
      }
    case Types.UPDATE_INSTITUTION:
      return {
        ...state,
        // institution: action.payload,
        loading: false,
      }
    case Types.DELETE_INSTITUTION:
      return {
        ...state,
        // institution: action.payload,
        loading: false,
      }
    case Types.REACTIVATE_INSTITUTION:
      return {
        ...state,
        // institution: action.payload,
        loading: false,
      }
    case Types.SET_LOADING:
      return {
        ...state,
        loading: true,
      }
    default: return state;
  }
};

export default Institutions;
